<template>
    <div :index="index">
        <!-- {{ inforBlock }} -->
        <div :index="index">
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_INPUT" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                            <div>
                                <InputText
                                    :id="`InputText-Form-${indexInputText}-${index}-${inforBlock.id}`"
                                    :model.sync="defaultForm.textValue"
                                    :config.sync="blockConfig.configFieldText"
                                />
                                <div v-if="inforBlock.block_input.confirm_input_twice == OPTION_YES_NO[0]?.id" class="mt-3 d-flex align-items-center">
                                    <InputText
                                        :id="`InputText-Confirmation-${indexInputText}-${index}-${inforBlock.id}`"
                                        :model.sync="defaultForm.confirmTextValue"
                                        :config.sync="blockConfig.configFieldText"
                                    />
                                    <span>{{ $t('managerForm.settingPage.confirmation') }}</span>
                                </div>
                            </div>
                            <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_TEXTAREA" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                            <TextareaComponent
                                :model.sync="defaultForm.textValue"
                                :cols="inforBlock.block_text_area.cols"
                                :rows="inforBlock.block_text_area.rows"
                                :style="{
                                    width: !inforBlock.block_text_area.cols ? '100%' : 'auto',
                                    minWidth: !inforBlock.block_text_area.cols ? '95%' : 'auto'
                                }"
                                :config.sync="blockConfig.configFieldTextarea"
                            >
                            </TextareaComponent>
                            <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                            <div class="d-flex">
                                <InputText
                                    :id="`InputPhone-1-Form-${inforBlock.id}`"
                                    :model.sync="defaultForm.phoneValue_1"
                                    style="min-width: 60px"
                                    :config.sync="blockConfig.configFieldPhone_1"
                                    :disabled="false"
                                />
                                <div class="p-1" style="font-size: 20px">-</div>
                                <InputText
                                    :id="`InputPhone-2-Form-${inforBlock.id}`"
                                    :model.sync="defaultForm.phoneValue_2"
                                    style="min-width: 50px"
                                    :config.sync="blockConfig.configFieldPhone_2"
                                    :disabled="false"
                                />
                                <div class="p-1" style="font-size: 20px">-</div>
                                <InputText
                                    :id="`InputPhone-3-Form-${inforBlock.id}`"
                                    :model.sync="defaultForm.phoneValue_3"
                                    style="min-width: 50px"
                                    :config.sync="blockConfig.configFieldPhone_3"
                                    :disabled="false"
                                />
                            </div>
                            <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                            <div class="d-flex" style="gap: 12px">
                                <div class="form-group row">
                                    <label class="col-sm-1 text-nowrap mt-2" style="min-width: 40px"
                                        >{{ inforBlock?.input_format?.first_name }}
                                    </label>
                                    <div class="col-sm-9">
                                        <InputText
                                            :id="`User-Last_Name-Form-${inforBlock.id}`"
                                            :model.sync="defaultForm.placeholderFirstName"
                                            :config.sync="blockConfig.configFieldFirstName"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-1 text-nowrap mt-2" style="min-width: 40px"
                                        >{{ inforBlock?.input_format?.last_name }}
                                    </label>
                                    <div class="col-sm-9">
                                        <InputText
                                            :id="`User-First_Name-Form-${inforBlock.id}`"
                                            :model.sync="defaultForm.placeholderLastName"
                                            :config.sync="blockConfig.configFieldLastName"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                            <div class="d-flex">
                                <InputText
                                    :id="`PostCode-1-Form-${inforBlock.id}`"
                                    :model.sync="defaultForm.postcodeValue_1"
                                    :config.sync="blockConfig.configFieldPostcode_1"
                                />
                                <div class="p-1" style="font-size: 20px">-</div>
                                <InputText
                                    :id="`PostCode-2-Form-${inforBlock.id}`"
                                    :model.sync="defaultForm.postcodeValue_2"
                                    :config.sync="blockConfig.configFieldPostcode_2"
                                />
                                <div v-if="inforBlock.block_post_code.feature_search_address == OPTION_YES_NO[0]?.id" class="ml-3">
                                    <button class="btn btn-light text-nowrap">
                                        {{ $t('managerForm.settingPage.btnAddrSearch') }}
                                    </button>
                                </div>
                            </div>
                            <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                            <InputText
                                :id="`KeywordBox-Form-${inforBlock.id}`"
                                :model.sync="defaultForm.textValue"
                                :config.sync="blockConfig.configFieldKeywordBox"
                                :disabled="false"
                            />
                            <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
            <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_DATE" :class="`form-group`">
                <div :class="`fm-answer`">
                    <div class="d-flex flex-column">
                        <div class="d-flex align-items-center" :style="`gap: 0.5rem;`">
                            <div v-html="inforBlock.additional_setting.note_left_block" style="width: fit-content; max-width: 120px" />
                            <div>
                                <div
                                    v-if="
                                        isShowDateFormType(inforBlock.block_date.format_year.type, inforBlock.block_date.format_month_day.type) ===
                                        'inputDate'
                                    "
                                >
                                    <DateNormal
                                        :id="`DateForm-${inforBlock.id}`"
                                        :full_date.sync="defaultForm.textValue"
                                        :config.sync="blockConfig.configFieldDate"
                                    >
                                    </DateNormal>
                                </div>

                                <div
                                    v-if="
                                        isShowDateFormType(inforBlock.block_date.format_year.type, inforBlock.block_date.format_month_day.type) ===
                                        'selectDate'
                                    "
                                    class="d-flex align-items-center flex-nowrap"
                                    style="gap: 10px"
                                >
                                    <Multiselect
                                        style="width: 180px"
                                        :value.sync="defaultForm.selectYear"
                                        :options="
                                            onHandleMergeOptionValues(
                                                generateYearList(
                                                    inforBlock.block_date.format_year.lower_limit,
                                                    inforBlock.block_date.format_year.upper_limit,
                                                    inforBlock.block_date.format_year.type_calendar
                                                ),
                                                inforBlock
                                            )
                                        "
                                        :config="{ trackBy: 'unique_key', label: 'label', isRemove: true }"
                                    />
                                    <Multiselect
                                        style="width: 180px"
                                        :value.sync="defaultForm.selectMonth"
                                        :options="onHandleMergeOptionValues(MONTH_OPTIONS, inforBlock)"
                                        :config="{ trackBy: 'unique_key', label: 'label', isRemove: true }"
                                    />
                                    <Multiselect
                                        style="width: 180px"
                                        :value.sync="defaultForm.selectDay"
                                        :options="onHandleMergeOptionValues(DAY_OPTIONS, inforBlock)"
                                        :config="{ trackBy: 'unique_key', label: 'label', isRemove: true }"
                                    />
                                </div>
                            </div>
                            <div v-html="inforBlock.additional_setting.note_right_block" style="width: fit-content; max-width: 120px" />
                        </div>
                        <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputText } from '@/components/Input';
import { renderLineBreaks } from '@/utils/format';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { OPTION_YES_NO } from '../constants';
import { generateYearList, MONTH_OPTIONS, DAY_OPTIONS, isShowDateFormType } from '../../../iframe-page/handlers';
import { onHandleMergeOptionValues } from '../../../handlers';
import TextareaComponent from '@/components/Textarea/main.vue';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

export default {
    name: 'CommonText',
    components: {
        InputText,
        TextareaComponent,
        DateNormal,
        Multiselect
    },
    props: {
        index: {
            type: Number,
            default: () => 0
        },
        inforBlock: {
            type: Object,
            default: () => null
        },
        formDefault: {
            type: Object,
            default: () => null
        },
        configBlock: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            blockConfig: this.configBlock,
            defaultForm: this.formDefault,
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            OPTION_YES_NO: OPTION_YES_NO,
            MONTH_OPTIONS: MONTH_OPTIONS,
            DAY_OPTIONS: DAY_OPTIONS,
            indexInputText: 0
        };
    },
    computed: {},
    methods: {
        generateYearList,
        onHandleMergeOptionValues,
        isShowDateFormType,

        textLineBreaks(text) {
            return renderLineBreaks(text);
        }
    },

    watch: {
        formDefault: {
            handler(newValue) {
                if (newValue) {
                    this.defaultForm = newValue;
                }
            },
            deep: true
        },

        configBlock: {
            handler(newValue) {
                if (newValue) {
                    this.blockConfig = newValue;
                }
            },
            deep: true
        },

        defaultForm: {
            handler(newValue) {
                this.$emit('update:formDefault', newValue);
            },
            deep: true
        },

        blockConfig: {
            handler(newValue) {
                this.$emit('update:configBlock', newValue);
            },
            deep: true
        }
    },

    created() {}
};
</script>

<style lang="scss" scoped></style>
